import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PageGuidedWorkflows } from 'GuidedWorkflowsApp/ts/interfaces/guided-workflows.response';

import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';

@Injectable({
    providedIn: 'root',
})
export class GuidedWorkflowsService {
    constructor(private ajaxService: AjaxService, private urlsService: UrlsService) {}

    getPageGuidedWorkflows(path: string): Observable<PageGuidedWorkflows[]> {
        const url = this.urlsService.getUrl(this.urlsService.GUIDED_WORKFLOWS.COLLECTION);
        return this.ajaxService.getDataObserveBody<PageGuidedWorkflows[]>(url, { path });
    }
}
